import { Divider, Tab, Tabs } from "@mui/material";
import { useState } from "react";
import { useTranslation } from "react-i18next";

import { MapEditorObservationPanelEcologicalFunctionFragment } from "../EcologicalFunctionCard/fragments.generated";
import CreateEcologicalFunctionTab from "./CreateEcologicalFunctionTab";
import { MapEditorObservationPanelEcologicalFunctionTypeFragment } from "./fragments.generated";
import LinkEcologicalFunctionTab from "./LinkEcologicalFunctionTab";

type LinkableEcologicalFunctionsProps = {
    createTo: (element: MapEditorObservationPanelEcologicalFunctionFragment) => string;
    ecologicalFunctionsLinkable: MapEditorObservationPanelEcologicalFunctionFragment[];
    onLinkClick: (ecologicalFunctionId: string) => void;
    onCreateFunction: (ecologicalFunctionTypeId: string) => void;
    ecologicalFunctionTypes: MapEditorObservationPanelEcologicalFunctionTypeFragment[];
};

export default function LinkableEcologicalFunctions({
    createTo,
    onLinkClick,
    onCreateFunction,
    ecologicalFunctionsLinkable,
    ecologicalFunctionTypes,
}: LinkableEcologicalFunctionsProps) {
    const { t } = useTranslation("mapEditor");

    const [activeTab, setActiveTab] = useState<"new" | "existing">(ecologicalFunctionsLinkable.length > 0 ? "existing" : "new");

    return (
        <>
            <Divider>{t("ecologicalFunctionLinking.dividerTitle")}</Divider>

            <Tabs centered variant="fullWidth" value={activeTab} onChange={(_event, newValue) => setActiveTab(newValue)}>
                {ecologicalFunctionsLinkable.length > 0 && (
                    <Tab value="existing" label={t("ecologicalFunctionLinking.tabLinkToExisting")} />
                )}
                <Tab value="new" label={t("ecologicalFunctionLinking.tabCreateNew")} />
            </Tabs>

            {activeTab === "existing" ? (
                <LinkEcologicalFunctionTab createTo={createTo} elements={ecologicalFunctionsLinkable} onLinkClick={onLinkClick} />
            ) : (
                <CreateEcologicalFunctionTab ecologicalFunctionTypes={ecologicalFunctionTypes} onCreate={onCreateFunction} />
            )}
        </>
    );
}
